<template>
  <div id="app" class="font-body">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useAuthStore } from "@/store/auth/AuthStore";
import { useBrickStore } from "@/store/brick/BrickStore";
import { useFleetStore } from "@/store/fleet/FleetStore";

export default defineComponent({
  name: "App",
  created() {
    window.addEventListener("beforeunload", this.beforeUnload);
  },
  setup() {
    useAuthStore().checkAuth();
  },
  methods: {
    beforeUnload() {
      const brickStore = useBrickStore();
      const fleetStore = useFleetStore();
      const dirtyLegId = brickStore.dirtyLegId;
      const dirtyActionId = brickStore.dirtyBoardActionId;
      const dirtyTruckId = fleetStore.dirtyTruckId;
      const dirtyDriverId = fleetStore.dirtyDriverId;
      const dirtySubcontractorId = fleetStore.dirtySubcontractorId;
      if (dirtyLegId) {
        brickStore.unlockLeg(dirtyLegId);
      }
      if (dirtyActionId) {
        brickStore.unlockFleetAction(dirtyActionId);
      }
      if (dirtyTruckId) {
        fleetStore.unlockTruck(dirtyTruckId);
      }
      if (dirtyDriverId) {
        fleetStore.unlockDriver(dirtyDriverId);
      }
      if (dirtySubcontractorId) {
        fleetStore.unlockSubcontractor(dirtySubcontractorId);
      }
    }
  }
});
</script>

<style lang="scss">
@use "assets/styles/global";
</style>
